"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const DateWidget = (props) => (react_1.default.createElement(react_hook_form_1.Controller, { name: props.name, control: props.formMethods.control, defaultValue: props.defaultValue, rules: { required: true }, render: ({ field: { onChange, onBlur, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState, }) => {
        return (react_1.default.createElement(react_datepicker_1.default, { selected: value ? new Date(value) : null, onChange: onChange, locale: "nl", dateFormat: "yyyy/MM/dd", className: "date " + (props.hasError && "fieldError") }));
    } }));
exports.default = DateWidget;
//# sourceMappingURL=DateWidget.js.map